import axios, { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { CHAT_API_URL, SHOW_LOGS } from 'config';
import { clearChatSession, getChatUser } from 'modules/Chat/Chat.helpers';
import ROUTE_PATHS from 'routes/values';

const chatApiConfigDefault = {
  baseURL: `${CHAT_API_URL.base}/${CHAT_API_URL.name}/${CHAT_API_URL.versions.V2}`,
  timeout: CHAT_API_URL.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
};

const ChatApiInstance = axios.create(chatApiConfigDefault);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (SHOW_LOGS) {
    console.info(`[request] [${JSON.stringify(config)}]`);
  }

  const authToken =
    config.headers.Authorization2 === null || config.headers.Authorization2
      ? config.headers.Authorization2
      : getChatUser().token;

  config.headers.set('Authorization2', authToken);

  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => Promise.reject(error);

const onResponse = (response: AxiosResponse): AxiosResponse => response;

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  const status = error.response ? error.response.status : null;

  switch (status) {
    case 401: {
      // Handle unauthorized access
      if (SHOW_LOGS) {
        console.error('UNAUTHORIZED', error);
      }
      clearChatSession();
      window.location.href = ROUTE_PATHS.WELCOME_TO_CHAT;
      break;
    }
    case 422:
      console.error('UNPROCESSABLE_ENTITY', error);
      break;
    case 500:
      console.error('SERVER_ERROR', error);
      break;
    case 404:
      console.error('FOUND_ERRORS', error);
      break;
    default:
      console.error('interceptors ERROR::', error);
  }

  return Promise.reject(error);
};

const setChatAuthToken = (token: string): void => {
  if (token) {
    ChatApiInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
};

ChatApiInstance.interceptors.request.use(onRequest, onRequestError);

ChatApiInstance.interceptors.response.use(onResponse, onResponseError);

export default ChatApiInstance;
export { chatApiConfigDefault, setChatAuthToken };
